export default __webpack_public_path__ + "static/media/mosae-litsoane-2023.b29c8649.pdf";